<app-advanced-response-selector [multiple]="true"
                                [targetType]="targetType"
                                [campaignId]="campaignId"
                                [resetSelectedFieldOnClose]="true"
                                [resetSelectedTypeOnClose]="true"
                                [selectedResponses]="selectedResponses"
                                (selectedResponsesChange)="onSelectedResponsesChanged($event)">
</app-advanced-response-selector>


<div class="mt-0025 mb-0075 ab-list-group-wrap--with-border"
     *ngIf="tagRules?.length > 0">
  <div style="max-height: 288px; overflow-y: auto">
    <mat-list class="ab-list-group
      ab-list-group--qb-selected-tags
      pt-0">
      <app-tag-list-item class="ab-list-item bg-color--white p-0"
                         style="min-height:50px;"
                         *ngFor="let rule of visibleTagRules; let i = index;trackBy:trackByTagId;"
                         (tagRemoved)="onRemoveRuleClick(rule)"
                         [tagId]="rule.id">

        <ng-container addLink>
          <ng-container [ngSwitch]="rule.tag_type">
            <ng-container *ngSwitchCase="'Date'">
              <a class="d-flex link link--small"
                 *ngIf="!showRange[rule.id]"
                 (click)="showRange[rule.id] = true">Add date range</a>
            </ng-container>
            <ng-container *ngSwitchCase="'Number'">
              <a class="d-flex link link--small"
                 *ngIf="!showRange[rule.id]"
                 (click)="showRange[rule.id] = true">
                Add range
              </a>
            </ng-container>
            <ng-container *ngSwitchCase="'Shift'">
              <a class="d-flex link link--small"
                 *ngIf="!showRange[rule.id]"
                 (click)="showRange[rule.id] = true">
                Add shift range
              </a>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container addContents>
          <div *ngIf="showRange[rule.id]">
            <ng-container [ngSwitch]="rule.tag_type">
              <app-date-tag-range-query-input *ngSwitchCase="'Date'"
                                              [ngModel]="rule"
                                              (ngModelChange)="dateTagItemUpdated(rule, $event)">
              </app-date-tag-range-query-input>

              <div *ngSwitchCase="'Number'"
                   class="flex mt-0050">
                <mat-form-field class="d-flex spacerRight">
                  <mat-label>Start Range</mat-label>
                  <input matInput
                         [ngModel]="rule.range_start"
                         (ngModelChange)="rangeStartChanged(rule, $event)"
                         type="text"
                         decimalMask>
                </mat-form-field>
                <mat-form-field class="d-flex">
                  <mat-label>End Range</mat-label>
                  <input matInput
                         [ngModel]="rule.range_end"
                         (ngModelChange)="rangeEndChanged(rule, $event)"
                         type="text"
                         decimalMask>
                </mat-form-field>
              </div>
              <ng-container *ngSwitchCase="'Shift'">
                <div class="caps mt-0025">
                  <strong>Start shift time</strong>
                  <span class="color--gray ml-0025">
                    (<button class="mimic-link uppercase color--red"
                            (click)="shiftStartChanged(rule, null)">Clear</button>)
                  </span>
                </div>
                <div class="mt-0025">
                  <app-day-time-input [ngModel]="rule.shift_start"
                                      (ngModelChange)="shiftStartChanged(rule, $event)"></app-day-time-input>
                </div>
                <div class="caps mt-0025">
                  <strong>End shift time</strong>
                  <span class="color--gray ml-0025">
                    (<button class="mimic-link uppercase color--red"
                            (click)="shiftEndChanged(rule, null)">Clear</button>)
                  </span>
                </div>
                <div class="mt-0025">
                  <app-day-time-input [ngModel]="rule.shift_end"
                                      (ngModelChange)="shiftEndChanged(rule, $event)"></app-day-time-input>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
        <ng-container addAttachment>
          <mat-checkbox (change)="attachmentsOnlyCheckboxChanged(rule)"
                        [checked]="rule.only_with_attachments"
                        class="mt-0050">Only with attachments</mat-checkbox>
        </ng-container>
      </app-tag-list-item>
    </mat-list>
  </div>
  <div class="clear-selected-responses-wrap">
    <div>
      <button class="link link--small" type="button" (click)="showMoreClicked()" *ngIf="this.tagRules.length > this.limit">Show more...</button>
    </div>
    <button class="link link--noline p-0 color--red txt-14"
            (click)="clearSelectedResponses()">Clear all selected responses</button>
  </div>
</div>


<div class="mt-0025 mb-0025 flex flexAlign--center query-by-source"
     *ngIf="tagRules?.length > 0">
  <app-include-exclude-having-toggle [targetType]="targetType"
                                     [operator]="operator"
                                     [lockIncludeExclude]="lockIncludeExclude"
                                     (operatorChange)="operatorChanged($event)"
                                     class="color--gray--004 txt-14"
                                     [forTypeText]="'responses'"></app-include-exclude-having-toggle>

  <app-date-range-and-users-query-link [dateRange]="dateApplied"
                                       [userIds]="createdByUserIds"
                                       (itemClicked)="dateRangeAndUsersClicked($event)">
  </app-date-range-and-users-query-link>
</div>
